import { v4 as uuidv4 } from "uuid";
class UtilServiceBase {
    convertHexadecimalToNumber(hexString) {
        return parseInt(hexString, 16);
    }
    getRandomDecimal(min, max) {
        return Math.random() * (max - min) + min;
    }
    getRandomInt(min, max) {
        const minVal = Math.ceil(min);
        const maxVal = Math.floor(max);
        return Math.floor(Math.random() * (maxVal - minVal + 1)) + minVal;
    }
    getRandomString(count) {
        let text = "";
        const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < count; i++) {
            const random = Math.floor(Math.random() * possible.length);
            text += possible[random];
        }
        return text;
    }
    getRandomAlphabet(count) {
        let txt = "";
        const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for (let i = 0; i < count; i++) {
            const random = Math.floor(Math.random() * alphabets.length);
            txt += alphabets[random];
        }
        return txt;
    }
    camelCaseToSentenceCase(text) {
        const result = text.replace(/([A-Z])/g, " $1");
        const rst = result.charAt(0).toUpperCase() + result.slice(1);
        return rst.trim();
    }
    toTitleCase(text) {
        return text.replace(/\w\S*/g, (txt) => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
    isValidPhoneNumber(_str) {
        if (isNaN(Number(_str))) {
            return false;
        }
        const isNum = /^\d+$/.test(_str);
        return isNum;
    }
    convertObjectPlainObject(objData) {
        const objDataPlain = JSON.parse(JSON.stringify(objData));
        return objDataPlain;
    }
    removeDuplicateString(items) {
        if (!Array.isArray(items)) {
            return [];
        }
        const unique = {};
        items.forEach((i) => {
            if (!unique[i]) {
                unique[i] = true;
            }
        });
        return Object.keys(unique);
    }
    objectHasAnyProperty(obj) {
        if (obj && typeof obj === "object") {
            return Object.keys(obj).length > 0;
        }
        return false;
    }
    waitUntilMilliseconds(ms) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve();
            }, ms);
        });
    }
    waitUntilSeconds(seconds) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, Math.round(seconds * 1000));
        });
    }
    waitUntilMunites(munites) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, Math.round(munites * 60 * 1000));
        });
    }
    generateDynamoTableKey(date) {
        const _now = date ? new Date(date) : new Date();
        const key = [
            `${_now.getFullYear()}`,
            `${_now.getMonth() + 1}`.padStart(2, "0"),
            `${_now.getDate()}`.padStart(2, "0"),
            "-",
            `${_now.getHours()}`.padStart(2, "0"),
            `${_now.getMinutes()}`.padStart(2, "0"),
            `${_now.getSeconds()}`.padStart(2, "0"),
            "-",
            uuidv4(),
        ];
        return key.join("");
    }
    encodeStringToBase64(str) {
        return Buffer.from(str).toString("base64");
    }
    decodeStringFromBase64(str) {
        return Buffer.from(str, "base64").toString();
    }
    isNumberic(val) {
        return !isNaN(Number(val));
    }
}
export const UtilService = new UtilServiceBase();
